// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1-wUl","paramInput":"JobSimulator_paramInput__2_nY_","input":"JobSimulator_input__185zJ"};